module.exports = __webpack_public_path__ + "img/undraw_Web_search_re_efla.71aecd9a.svg";